export enum TimeResolutionInDays {
  TWO_WEEKS = 14,
  ONE_MONTH = 30,
  TWO_MONTHS = 60,
  SIX_MONTHS = 182,
  TWO_YEARS = 730,
  FOUR_YEARS = 1460
}